import { SVGAttributes, VFC } from "react";

// eslint-disable-next-line react/require-default-props
const ArrowSelect: VFC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M2 5L8 11L14 5" stroke="#282828" strokeWidth="1.5" />
    </svg>
  );
};

export { ArrowSelect };
